export default "__VITE_ASSET__xqdZtyF7__"